import React, { lazy } from 'react';
const bonuses = [{
  num: '1',
  img: 'https://cdn.magicpatterns.com/uploads/qn4P9d4ichCcobJaqYgbbV/f9120000-401a-42df-ac72-752e04cec302-mockup.webp',
  title: 'The Studio-Ready Admin Pack',
  desc: 'Run your practice like a pro. Waivers, intake forms, and business essentials ready to use from day one.',
  value: '$19'
}, {
  num: '2',
  img: 'https://cdn.magicpatterns.com/uploads/99wwZ25ZxV3RVWzsNkBB2z/ff551465-b1f6-4b32-8b58-0620490ddbd2-mockup_(1).webp',
  title: 'Digital Handout Templates',
  desc: 'Beautiful, ready-to-share handouts that make your classes look polished and professional.',
  value: '$19'
}, {
  num: '3',
  img: 'https://cdn.magicpatterns.com/uploads/avLTCGf5kkDekXcHvw7FqS/7d9835e5-3ad5-4c87-8ef7-9f18ae25ae2e-mockup_(1).webp',
  title: 'The 12-Month Theme Calendar',
  desc: 'A full year of thoughtful, ready-to-teach themes so you never run out of inspiration.',
  value: '$19'
}, {
  num: '4',
  img: 'https://cdn.magicpatterns.com/uploads/jzAR4wkH122Em1vNU3Zd7N/c744ad05-af23-41db-86a5-e68b02007724-mockup.webp',
  title: 'The Verbal Cues Bible',
  desc: 'Clear, professional cues for every pose so you always know exactly what to say.',
  value: '$19'
}, {
  num: '5',
  img: 'https://cdn.magicpatterns.com/uploads/bWTqiYvWQbv6xaus9RY5MS/9fde8400-263a-40b2-99ef-0061980fb596-mockup.webp',
  title: 'The Student Progress System',
  desc: 'Track student growth and evolution to keep your community engaged and coming back.',
  value: '$19'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-16">
      <div className="max-w-3xl mx-auto" data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-19">
            🎁 Plus 5 Exclusive Bonuses
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium" data-id="element-20">
            Valued at{' '}
            <span className="line-through text-secondary" data-id="element-21">$95 USD</span> — Your
            total professional toolkit, included{' '}
            <span className="font-bold text-primary" data-id="element-22">FREE</span>
          </p>
        </div>

        <div className="space-y-4" data-id="element-23">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light flex items-start gap-4 sm:gap-6 shadow-sm" data-id="element-24">
              <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-primary text-white flex items-center justify-center font-bold text-sm sm:text-base flex-shrink-0" data-id="element-25">
                {bonus.num}
              </div>
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-xl overflow-hidden flex-shrink-0 border border-border-light bg-bg-main" data-id="element-26">
                <img src={bonus.img} alt={bonus.title} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-27" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-28">
                <h3 className="text-text-main font-bold text-base sm:text-lg leading-tight mb-1" data-id="element-29">
                  {bonus.title}
                </h3>
                <p className="text-text-sec text-sm mb-2 leading-snug" data-id="element-30">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-2 text-sm sm:text-base" data-id="element-31">
                  <span className="text-secondary line-through font-medium" data-id="element-32">
                    {bonus.value}
                  </span>
                  <span className="text-primary font-bold" data-id="element-33">FREE</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}